import React, { Component } from "react";
import includes from "lodash/includes";
// import { Image } from "semantic-ui-react";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
// import ImageGallery from 'react-image-gallery';
import { fetchAppParameter } from "../../actions/commonAction";
import { closeModal } from "../../actions/modalAction";
import { select, deselect, resetSelections } from "../../actions/commonAction";
import Confirm from "../common/Confirm_1";
import CheckboxInput from "../form/CheckboxInput_2";
import { imageDomain,multipleImageURL } from "../configC/keys";
import { MdClose } from "react-icons/md";

class ShowImages extends Component {
  state = {
    open: false,
  };

  handleClearSelections = () => {
    this.props.resetSelections();
  };

  onChange(item) {
    if (includes(this.props.selections, item)) {
      this.props.deselect(item);
    } else {
      this.props.select(item);
    }
  }
  //**********************
  showBulk = () => {
    this.setState({ open: true });
  };

  //**********************

  handleConfirmBulk = async () => {
    const paths = this.props.selections;
    const imageURL = multipleImageURL;

    const imgRoute = "api/ImageDeleteBulk";
    const apiRoute = this.props.apiRoute;
    //************

    try {
      const resImage = await axios.post(`${imageURL}/${imgRoute}`, { paths });
      if (resImage.data.msg === "success") {
        const values = {
          action: "delete",
          id: this.props.id,
          images: paths,
        };

        const res = await axios.put(`${apiRoute}`, values);
        if (res.data.msg === "success") {
          this.props.handleRefresh();
          this.setState({ open: false });
          this.handleClearSelections()
          toastr.success("Image Deleted Successfully");
        }
      }
    } catch (error) {
      console.log("error_imageDelete", error);
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        toastr.error("Oops", "Something went wrong.Please Try Again");
      }
    }

    //**********
  };

  handleCancelBulk = () => this.setState({ open: false });
  // @@@@@@@

  //******************
  renderDeleteButtonBulk = () =>
    // this.props.userA !== null &&
    //   this.props.userA.userType === "admin"
    this.props.selections.length > 0  ? (
      <span onClick={() => this.showBulk()} className="icon-button ml-05">
        <img
          className="yimg "
          src="/deleteIcon.png"
          alt=" "
          style={{
            width: "25px",
            height: "25px",
            borderRadius: "5px",
            verticalAlign: "middle",
          }}
        />
      </span>
    ) : (
      <div></div>
    );
  //^^^^^^^^^^^
  renderButton() {
    if (
      this.props.images &&
      this.props.images.length > 0 &&
      this.props.userA !== null &&
      (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') 
    ) {
      return (
        <div className="flex-center mb-20">
          <div className="font-20B color-dodgerblue">
            Select Images To Delete
          </div>
          {this.renderDeleteButtonBulk()}
        </div>
      );
    }
  }
  // @@@@@

  renderList = (item) => {
    return (
      <div key={item}>
        {/**/}
        <div className="flex-center nowrap" style={{ position: "relative" }}>
          {this.props.userA !== null &&
             (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') &&  
            (
              <span className="topleft font-24B">
                <CheckboxInput
                  checked={includes(this.props.selections, item)}
                  onChange={() => this.onChange(item)}
                />
              </span>
            )}

          <img
            className="image-respo mb-20"
            alt="image_"
            src={`${imageDomain}/${item}`}
          />
        </div>
      </div>
    );
  };

  //^^^^^^^^^^^^^^^^^^^^^^^^^^^
  render() {
    const renderImages = () => {
      if (this.props.images.length > 0) {
        return this.props.images.map(this.renderList);
      } else {
        return <div className="card-noShow">Oops ! No Image Available</div>;
      }
    };

    //***** */
    return (
      <div className="main-div" style={{ position: "relative" }}>
        <span
          className="modal-close-btn flex-center"
          onClick={this.props.closeModal}
        >
          <MdClose />
        </span>
        <div style={{ padding: "15px" }}>
          {/**/}
          <Confirm
            // message={this.props.message}
            open={this.state.open}
            onCancel={this.handleCancelBulk}
            onConfirm={this.handleConfirmBulk}
          />
          {/**/}
          <div>
            {/**/}
            <div className=" ">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  padding: "5px",
                }}
              >
                All Images
              </div>
            </div>

            {this.renderButton()}
            {renderImages()}
          </div>
        </div>
      </div>
    );

    //@@@
  }
}

const mapState = (state) => {
  return {
    state,
    userA: state.auth.userA,
    selections: state.commons.selections,
  };
};
export default connect(mapState, {
  closeModal,
  select,
  deselect,
  resetSelections,
  fetchAppParameter,
})(ShowImages);
